export const getSorting = (sort, sortBy, natural) => {
  return sort === 'desc' ? sortDescending(sortBy, natural) : sortAscending(sortBy, natural);
};

const sortDescending = (sortBy, natural) => (a, b) => {
  if (a[sortBy] === null) return 1;
  if (b[sortBy] === null) return -1;
  let aProxy = a[sortBy];
  let bProxy = b[sortBy];
  if (natural) {
    aProxy = natValue(aProxy);
    bProxy = natValue(bProxy);
  }
  if (bProxy === aProxy) return 0;
  return bProxy < aProxy ? -1 : 1;
};

const sortAscending = (sortBy, natural) => (a, b) => {
  if (a[sortBy] === null) return -1;
  if (b[sortBy] === null) return 1;
  let aProxy = a[sortBy];
  let bProxy = b[sortBy];
  if (natural) {
    aProxy = natValue(aProxy);
    bProxy = natValue(bProxy);
  }
  if (bProxy === aProxy) return 0;
  return aProxy < bProxy ? -1 : 1;
};

/**
 * Reformat a value in an attempt to have it sort better.
 * Force to string.
 * zero-pad numbers to the length of padding variable
 * treat dotted numbers as versioning
 * Lower case
 * @param value - value to be reformatted
 * @returns reformatted value
 * */
const natValue = (value) => {
  const padding = value => "00000000000000000000".slice(value.length);
  const toString = value => value ? String(value) : '';
  const fixNumbers = (value) => {
    return value.replace(/(\d+)((\.\d+)+)?/g, ($0, integer, decimal, $3) => {
      if (decimal !== $3) {
        return $0.replace(/(\d+)/g, $d => padding($d) + $d);
      }
      decimal = decimal || ".0";
      return padding(integer) + integer + decimal + padding(decimal);
    });
  };
  return fixNumbers(toString(value)).toLowerCase();
};
